import { PersistentResource } from './api';

export enum V3AbsenceValuationMethodSubjectType {
  ABSENCE_TYPE = 'ABSENCE_TYPE',
  PUBLIC_HOLIDAY = 'PUBLIC_HOLIDAY',
}

export enum V3AbsenceValuationMethodMethod {
  FIXED_TARGET = 'FIXED_TARGET',
  FIXED_OVERRIDE = 'FIXED_OVERRIDE',
  AVERAGE_13_WEEK = 'AVERAGE_13_WEEK',
  AVERAGE_12_MONTH = 'AVERAGE_12_MONTH',
  ZERO = 'ZERO',
}

export interface V3AbsenceValuationMethod extends PersistentResource<number> {
  '@type': 'com.crewmeister/AbsenceValuationMethod';
  crewId: number | null;
  userId?: number | null;
  teamId?: number | null;
  validFrom: string;
  validTo: string;
  subjectType: V3AbsenceValuationMethodSubjectType;
  absenceTypeId?: number | null;
  method: V3AbsenceValuationMethodMethod;
  fixedHoursOverride?: number | null;
}
